import RejectLoan from "./RejectLoan.jsx";

export default RejectLoan;
